
import { Station, StationItem } from "@/commons/interface/building/station";
import { StdResponse, bimAxios } from "@/config/axios"
import qs from "qs";


export function findStationDetailByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/stations/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function findStationListByprojectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/stations`, {
        params: {
            ...params,
        }
    })
}

export function addStation(projectUuid: string, data: Station, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/stations`, data, {
        params: {
            ...params,
        }
    })
}

export function updateStation(uuid: string, data: Station, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/stations/${uuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function updateStationItem(id: number, data: StationItem, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/station-items/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteStationByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/stations/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function deleteStationByUuidList(uuids: string[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/stations`, {
        params: {
            uuids: uuids,
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function deleteStationByprojectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/projects/${projectUuid}/stations`, {
        params: {
            ...params,
        }
    })
}